import React from 'react';

const IconInfoBox = ({ item }) => {
  return (
    <div className={'icon-info-box'}>
      <h3 className={'icon-info-box-title'}>{item.title}</h3>
      <p className={'icon-info-box-desc'}>{item.text}</p>
      {/* 이미지가 있을 때만 출력 */}
      {item.image ? (
        <div className={'icon-info-img-wrapper'}>
          <figure className={'icon-info-img-group'}>
            <img
              src={item.image || '/img_no_img.png'}
              alt='product detail image'
              className={'icon-info-img'}
              onError={(e) => {
                e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
                e.target.src = '/img_no_img.png';
              }}
              decoding={'async'}
            />
          </figure>
        </div>
      ) : null}
    </div>
  );
};

export default IconInfoBox;
